import styled from 'styled-components';
import { Typography } from '@material-ui/core';
import Close from '@material-ui/icons/Close';


export const Content = styled.div`
  outline: 0px solid transparent;
  background-color: white;
  width: 300px;
  margin: auto;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
`;

export const Image = styled.img.attrs(({ src }) => ({
  src,
}))`
  width: 100%;
`;

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 12px;
`;

export const TimeclockInfo = styled.div``;

export const Name = styled(Typography)`
  font-size: 16px;
  max-width: 20ch;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
export const Date = styled(Typography)`
  font-size: 16px;
`;

export const Temperature = styled(Typography)`
  font-size: 13px;
  font-weight: bold;
  color: white;
  margin-left: auto;
  padding: 2px 8px;
  border-radius: 4px;
  background-color: ${props => props.color};
`;

export const SlideItem = styled.div``;

export const CloseButton = styled.div`
  cursor: pointer;
  display: flex;
  position: absolute;
  z-index: 1;
  right: -11px;
  height: 22px;
  width: 22px;
  transform: translateY(-30%);
  background-color: white;
  border-radius: 50%;
`;

export const CloseIcon = styled(Close)`
  margin: auto;
  font-size: 16px;
`;

